import { InformacionBasicaAgente } from './informacio-basica-agente.class';
import { InformacionComplementariaAgente } from './informacion-complementaria-agente.class';
import { FiltroAgente } from '../filtro/filtro-agente';

export abstract class Agente {

    informacionBasica: InformacionBasicaAgente;

    informacionComplementaria: InformacionComplementariaAgente;

    constructor() {
        this.informacionBasica = new InformacionBasicaAgente();
        this.informacionComplementaria = null;
    }

    public getDniAgente(): String {
        return this.informacionComplementaria.asesor.dni;
    }
    public getCodigoAgente(): String {
        return this.informacionComplementaria.asesor.codigo;
    }

    public habilitarOpcionesAgente(): boolean {
        return this.informacionComplementaria !== undefined && this.informacionComplementaria !== null;
    }

    public isAsesor(): boolean {
        return true;
    }

    public abstract getRestriccionSeleccionAgente();

    public getFiltroAgente(): FiltroAgente {
        const filtroAgente = new FiltroAgente();
        filtroAgente.codAsesor = this.informacionComplementaria.asesor.codigo;
        filtroAgente.loginAsesor = this.informacionComplementaria.asesor.dni;
        return filtroAgente;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/agente/agente.class.ts